var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcDevices = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M4.5 20a1 1 0 0 1 1-1H8a1 1 0 1 1 0 2H5.5a1 1 0 0 1-1-1M16 17a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H17a1 1 0 0 1-1-1",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M14 5a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1zm-3 1a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3h-6a3 3 0 0 1-3-3zm-9.12-.12A3 3 0 0 1 4 5h4a1 1 0 0 1 0 2H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h4a1 1 0 1 1 0 2H4a3 3 0 0 1-3-3V8a3 3 0 0 1 .88-2.12",
  clipRule: "evenodd"
})));
export default SvgIcDevices;